var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxCon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C20.7273 21.2033 20.4293 21.379 20.106 21.527C19.066 22 17.692 22 14.943 22H9.057C6.308 22 4.934 22 3.894 21.527C3.57783 21.3842 3.27808 21.2075 3 21M18.5 10H18.491M5.5 10H5.491M2 10C2 6.463 2 4.694 3.053 3.513C3.22167 3.32367 3.40633 3.14967 3.607 2.991C4.862 2 6.741 2 10.5 2H13.5C17.259 2 19.138 2 20.392 2.99C20.5933 3.15 20.7783 3.32433 20.947 3.513C22 4.693 22 6.463 22 10C22 13.537 22 15.306 20.947 16.487C20.7774 16.6767 20.5917 16.8514 20.392 17.009C19.138 18 17.26 18 13.5 18H10.5C6.741 18 4.862 18 3.607 17.01C3.40756 16.852 3.2222 16.677 3.053 16.487C2 15.307 2 13.537 2 10Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.551 10C14.551 10.663 14.2876 11.2989 13.8188 11.7678C13.35 12.2366 12.7141 12.5 12.051 12.5C11.388 12.5 10.7521 12.2366 10.2833 11.7678C9.81442 11.2989 9.55103 10.663 9.55103 10C9.55103 9.33696 9.81442 8.70107 10.2833 8.23223C10.7521 7.76339 11.388 7.5 12.051 7.5C12.7141 7.5 13.35 7.76339 13.8188 8.23223C14.2876 8.70107 14.551 9.33696 14.551 10Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxCon);
export default __webpack_public_path__ + "static/media/tax-con.ae689cd6f5d21d0e6a2cc89873a875f4.svg";
export { ForwardRef as ReactComponent };